import Head from 'next/head';
import { Component } from 'react';

import SideMenu from '../components/SideMenu';
import TopMenu from '../components/TopMenu';
import MainHeader from '../components/MainHeader';
import Config from '../lib/Config';

export default class Main extends Component {
  render() {
    const {
      children, title, className, header, sideMenu, topMenu, ariaLabel
    } = this.props;

    return (
      <div aria-label={ariaLabel}>
        <Head>
          <title>{(title ? title + ' - ' : '') + Config.name}</title>
        </Head>

        <div style={{ display: 'flex' }}>
          {topMenu && <TopMenu />}

          {sideMenu && <SideMenu />}

          <div style={{ width: '100%' }}>
            {header && <MainHeader {...header} />}

            <div className={className} style={{ marginLeft: sideMenu ? 60 : 0 }}>
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
